import cn from 'classnames';

import { FlagIssue } from '../../../config/utils';
import css from './chip.module.scss';

interface Props {
    issue: FlagIssue;
}
export function Chip({ issue }: Props) {
    return (
        <span
            className={cn(css.badge, {
                [css.error]: issue.severity === 'error',
                [css.warning]: issue.severity === 'warning',
            })}
        >
            {issue.rule}
        </span>
    );
}
